import React, { Component } from "react";
import PersonnelRow from "./personnel-row.js";
import PersonnelForm from "./personnel-form.js";
import Filter from "./filter.js";

import "./personnel-list.css";

class PersonnelList extends Component {

    constructor(props) {
        super(props);

        this.FORM_MODES = {
            ADD: 1,
            EDIT: 2
        }

        this.state = {
            filter: "",
            show_personnel_form: false,
            editing_personnel_info: false,
            clear: false,
            form_mode: this.FORM_MODES.ADD,
            edit_personnel_id: -1,
            edit_personnel_name: ""
        };
    }

    updateFilter(newFilter) {
        newFilter = newFilter.toLowerCase();
        this.setState({ filter: newFilter });
    }

    startEdit(personnelInfo) {
        this.setState({
            editing_personnel_info: personnelInfo,
            show_personnel_form: true,
            form_mode: this.FORM_MODES.EDIT,
            edit_personnel_id: personnelInfo.id,
            edit_personnel_name: personnelInfo.first_name + " " + personnelInfo.last_name,
            locked_out: personnelInfo.lockout
        })
    }

    async addPersonnel(personnelData) {
        let { add_personnel } = this.props;
        await add_personnel(personnelData);
    }

    async editPersonnel(editData) {
        let { edit_personnel } = this.props;
        let { edit_personnel_id } = this.state;
        await edit_personnel(edit_personnel_id, editData);
    }

    showPersonnelForm() {
        this.setState({
            show_personnel_form: true,
            form_mode: this.FORM_MODES.ADD
        });
    }

    hidePersonnelForm() {
        let { personnel_form_hidden } = this.props;

        this.setState({
            show_personnel_form: false,
            clear: true,
            form_mode: this.FORM_MODES.ADD
        });

        personnel_form_hidden();
    }

    checkUserOrganizationFilter(selectedOrganizations, userOrganizationNames) {
        for (let index in selectedOrganizations) {
            let currentOrganization = selectedOrganizations[index];
            if (userOrganizationNames.indexOf(currentOrganization.name) > -1) {
                return true;
            }
        }
        return false;
    }

    printPersonnel() {
        let { personnel_data, selected_organizations } = this.props;
        let { filter } = this.state;

        return personnel_data.map((personnel) => {
            let personnelName = personnel.first_name + " " + personnel.last_name;
            personnelName = personnelName.toLowerCase();
            let email = personnel.email ? personnel.email.toLowerCase() : "";
            let role = personnel.role.name.toLowerCase();
            let userOrganizationNames = personnel.organizations.organization_names;
            let personnelID = personnel.id;

            if (filter === "" || personnelName.includes(filter) || email.includes(filter) || role.includes(filter)) {
                if (selected_organizations.length > 0) {
                    if (this.checkUserOrganizationFilter(selected_organizations, userOrganizationNames)) {
                        return <PersonnelRow key={personnelID} personnel_data={personnel} start_edit={this.startEdit.bind(this)} set_personnel_lockout_status={this.setPersonnelLockoutStatus.bind(this)} />;
                    }
                    return "";
                }
                else {
                    return <PersonnelRow key={personnelID} personnel_data={personnel} start_edit={this.startEdit.bind(this)} set_personnel_lockout_status={this.setPersonnelLockoutStatus.bind(this)} />;
                }
            }
            else {
                return "";
            }
        })
    }

    async setPersonnelLockoutStatus(personnelID, newStatus) {
        let { set_personnel_lockout } = this.props;
        await set_personnel_lockout(personnelID, newStatus);
    }

    archiveDone(personnelID) {
        let { archive_done } = this.props;
        archive_done(personnelID);
    }

    render() {
        let { organizations, roles, errors, should_hide_form, token } = this.props;
        let { show_personnel_form, clear, editing_personnel_info, form_mode, edit_personnel_id, edit_personnel_name } = this.state;
        let set = false;
        let shouldClear = false;

        if (clear) {
            shouldClear = clear;
            this.setState({ clear: false });
        }

        if (should_hide_form) {
            this.hidePersonnelForm();
        }

        if (editing_personnel_info) {
            set = {
                first_name: editing_personnel_info.first_name,
                last_name: editing_personnel_info.last_name,
                email: editing_personnel_info.email,
                role: editing_personnel_info.role.id.toString(),
                organizations: editing_personnel_info.organizations.organizations,
                send_usage_email: editing_personnel_info.send_usage_email
            };
            this.setState({ editing_personnel_info: false });
        }

        let editPersonnelData = {
            id: edit_personnel_id,
            name: edit_personnel_name
        };

        return (
            <div className='personnel_list'>
                <div className='personnel_list_title'>Manage Personnel</div>
                <PersonnelForm hide_func={this.hidePersonnelForm.bind(this)} show={show_personnel_form} mode={form_mode} set={set} clear={shouldClear} organizations={organizations} roles={roles} add_personnel={this.addPersonnel.bind(this)} edit_personnel={this.editPersonnel.bind(this)} errors={errors} edit_personnel_data={editPersonnelData} token={token} archive_done={this.archiveDone.bind(this)} />
                <Filter update_filter={this.updateFilter.bind(this)} />
                <button className='personnel_list_add_personnel' onClick={this.showPersonnelForm.bind(this)}>Add Personnel</button>
                <table className='personnel_table'>
                    <thead>
                        <tr className='personnel_table_row'>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Facility</th>
                            <th>Send Data Usage Email</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.printPersonnel()}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default PersonnelList;



// WEBPACK FOOTER //
// ./src/components/containers/manager-dashboard/manage-personnel/personnel-list.js